import { find } from 'lodash-es';

export const isOutOfStock = (product) => {
  const name = find(product?.attributesRaw, { name: 'is-sellable' });
  return name?.value?.key === 'OutOfStock';
};
export const remapQuantities = ({
  QuantityToCreate: qtc,
  amounts,
  atcQuantity,
  isUsedForAddToCart,
}): {
  quantityToCreate: any;
  amounts: any;
  atcQuantity: any;
  isUsedForAddToCart: any;
} => ({
  quantityToCreate: qtc?.fields?.quantityToCreate,
  amounts: amounts.map(({ fields: f }) => f),
  atcQuantity,
  isUsedForAddToCart,
});
